import usePlaygroundDemoChromeVisible from './usePlaygroundDemoChromeVisible';

/**
 * "LIVE DEMO" pill beside the logo in the nav while QA Playground is ON (#9141). Exact
 * styling from the design prototype.
 */
const PlaygroundLiveDemoBadge = () => {
  if (!usePlaygroundDemoChromeVisible()) {
    return null;
  }

  return (
    <span
      data-testid="playground-demo-chrome"
      className="rounded-full bg-white/[0.18] px-2.5 py-[3px] text-[10.5px] font-bold tracking-[0.04em] whitespace-nowrap text-white"
    >
      LIVE DEMO
    </span>
  );
};

export default PlaygroundLiveDemoBadge;
